import React, { useState, useEffect,useRef } from 'react';
import './Header.css';
import logo from '../Image/image.png';
import { useNavigate } from 'react-router-dom';
import { initFacebookPixel } from '../facebookPixel';
import { FaVolumeUp, FaVolumeMute } from 'react-icons/fa';
const Header = () => {
  const navigate = useNavigate();
  const generateDeviceId = () => {
    return `${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
  };

  const [remainingTime, setRemainingTime] = useState(0);
  const [deviceId, setDeviceId] = useState(null);

  // Fixed target end date: March 20, 2025
  const endDate = new Date('February 28, 2025 00:00:00').getTime();

  const calculateRemainingTime = () => {
    const timeRemaining = endDate - Date.now();
    return timeRemaining > 0 ? timeRemaining : 0;
  };

  const formatTime = (time) => {
    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((time % (1000 * 60)) / 1000);

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  };

  useEffect(() => {
    let storedDeviceId = localStorage.getItem('deviceId');

    if (!storedDeviceId) {
      storedDeviceId = generateDeviceId();
      localStorage.setItem('deviceId', storedDeviceId);
    }

    setDeviceId(storedDeviceId);

    const intervalId = setInterval(() => {
      const remaining = calculateRemainingTime();
      setRemainingTime(remaining);

      if (remaining <= 0) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  const [isMuted, setIsMuted] = useState(true); // Start with video muted
  const videoRef = useRef(null);

  const toggleMute = () => {
    if (videoRef.current) {
      const newMuteState = !isMuted;
      setIsMuted(newMuteState);
      videoRef.current.muted = newMuteState; // Toggle mute state on video element
    }
  };

  return (
    <>
      <div className="header">
      <div className="header-video-container" onClick={() => videoRef.current.play()}>
      <video
        ref={videoRef}
        className="header-video"
        src="https://machaxidev.blob.core.windows.net/frontend-machaxi/BadmintonCoachinglp.mp4"
        autoPlay
        loop
        playsInline
        muted={isMuted} // Set mute state based on state
        controls={false} // Disable controls to prevent user from manually muting/unmuting
      >
        Your browser does not support the video tag.
      </video>
      <div className="sound-icon" onClick={toggleMute} style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer' }}>
        {isMuted ? <FaVolumeMute size={30} color="white" /> : <FaVolumeUp size={30} color="white" />}
      </div>
    </div>
      </div>

      {/* Button positioned visually between Header and next section */}
      {/* <div className="enroll-now-container">
      <div
        className="enroll-now-btn"
      >
        <div className="header-timer">OFFER ENDING IN</div>
          <div className="timing">{formatTime(remainingTime)}</div>
      </div>
    </div> */}
    </>
  );
};

export default Header;
